import React from 'react';
import { HiOutlineUserGroup, HiOutlineChartBar, HiOutlineExclamationCircle, HiOutlineTrendingUp } from 'react-icons/hi';
import type { IconType } from 'react-icons';
import './UseCases.css';

const IconWrapper: React.FC<{ Icon: IconType; color: string }> = ({ Icon, color }) => {
  const IconComponent = Icon as any;
  return <IconComponent style={{ color }} />;
};

interface UseCase {
  Icon: IconType;
  title: string;
  description: string;
  benefits: string[];
  color: string;
}

const useCases: UseCase[] = [
  {
    Icon: HiOutlineChartBar,
    title: 'Métricas de Engenharia',
    description: 'Entenda o desempenho do seu time com métricas de ciclo, lead time e throughput',
    color: 'var(--chart-1)',
    benefits: [
      'Cycle time e lead time em tempo real',
      'Throughput de PRs e análise de tendências',
      'Taxa de merge e aprovação',
      'Métricas consolidadas por repositório'
    ]
  },
  {
    Icon: HiOutlineUserGroup,
    title: 'Medir Performance de Contribuidores',
    description: 'Use o Opindex para avaliar e desenvolver seu time de forma objetiva e justa',
    color: 'var(--chart-1)',
    benefits: [
      'Índice único de performance (Opindex)',
      'Análise de volume, qualidade, complexidade e engajamento',
      'Ranking e comparação entre contribuidores',
      'Evolução histórica e feedback personalizado'
    ]
  },
  {
    Icon: HiOutlineExclamationCircle,
    title: 'Gestão de Incidentes',
    description: 'Monitore e gerencie incidentes para melhorar a confiabilidade dos seus sistemas',
    color: 'var(--chart-5)',
    benefits: [
      'MTTR e MTBF em tempo real',
      'Gestão completa de incidentes com timeline',
      'Postmortem estruturado e análise de causa raiz',
      'Análise de tendências e padrões de falha'
    ]
  },
  {
    Icon: HiOutlineTrendingUp,
    title: 'Otimizar Processos',
    description: 'Identifique gargalos e otimize seu processo de desenvolvimento',
    color: 'var(--chart-3)',
    benefits: [
      'Identifique gargalos no processo',
      'Monitore frequência e sucesso de deploys',
      'Análise de reviews e code quality',
      'Insights acionáveis para melhorias'
    ]
  }
];

export const UseCases: React.FC = () => {
  return (
    <section className="use-cases-section">
      <div className="use-cases-container">
        <div className="use-cases-header">
          <h2 className="use-cases-title">Casos de uso reais</h2>
          <p className="use-cases-subtitle">
            Veja como times de engenharia estão usando o Opsight para melhorar
          </p>
        </div>
        <div className="use-cases-grid">
          {useCases.map((useCase, index) => (
            <div key={index} className="use-case-card">
              <div className="use-case-icon">
                <IconWrapper Icon={useCase.Icon} color={useCase.color} />
              </div>
              <h3 className="use-case-title">{useCase.title}</h3>
              <p className="use-case-description">{useCase.description}</p>
              <ul className="use-case-benefits">
                {useCase.benefits.map((benefit, benefitIndex) => (
                  <li key={benefitIndex}>
                    <span className="benefit-check">✓</span>
                    {benefit}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

